import type { ActionMenuItem } from './ActionMenu';
import type { ActionBarItem } from './ActionBar';

const isDangerVariant = (variant: ActionBarItem['variant']): boolean =>
    variant === 'destructive' || variant === 'error';

export const buildActionBarMenuItems = (buttons: ActionBarItem[]): ActionMenuItem[] =>
    buttons.flatMap((button, index) => {
        const entries: ActionMenuItem[] = [];

        if (button.dividerBefore && index > 0) {
            entries.push({ type: 'divider', key: `divider-${index}` });
        }

        entries.push({
            key: `${button.label}-${index}`,
            label: button.label,
            disabled: button.disabled,
            danger: isDangerVariant(button.variant),
            tooltip: button.tooltip,
            icon: button.icon,
            onClick: button.onClick,
        });

        return entries;
    });
